import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { T } from '@tolgee/react';
import { OptimizedImage } from '../../../components/ui/OptimizedImage';

// Datos de categorías de Jarad actualizados con nuevo diseño
const jaradCategories = [
  {
    id: 1,
    name: 'Aves',
    nameKey: 'categories.birds.name',
    slug: 'AVES',
    description: 'Productos especializados para aves',
    descriptionKey: 'categories.birds.description',
    image: '/images/Aves.png',
    color: '#afc5a1',
    icon: '🐦'
  },
  {
    id: 2,
    name: 'Roedores',
    nameKey: 'categories.rodents.name',
    slug: 'ROEDORES',
    description: 'Todo lo que necesitan tus pequeñas mascotas',
    descriptionKey: 'categories.rodents.description',
    image: '/images/Roedores.png',
    color: '#f8d662',
    icon: '🐰'
  },
  {
    id: 3,
    name: 'Gatos',
    nameKey: 'categories.cats.name',
    slug: 'GATOS',
    description: 'Alimentación y cuidados para tu felino',
    descriptionKey: 'categories.cats.description',
    image: '/images/Gatos.png',
    color: '#e0caaf',
    icon: '🐱'
  },
  {
    id: 4,
    name: 'Perros',
    nameKey: 'categories.dogs.name',
    slug: 'PERROS',
    description: 'Todo para el bienestar y alimentación de tu perro',
    descriptionKey: 'categories.dogs.description',
    image: '/images/Perros.png',
    color: '#c5ba9e',
    icon: ''
  }
];

const Categories = () => {
  return (
    <div className="py-16">
      <div className="content-container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {jaradCategories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
            >
              <Link
                to={`/products?page=1&category=${category.slug}`}
                className="group block"
              >
                <div
                  className="aspect-square rounded-2xl relative overflow-hidden transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl"
                  style={{ backgroundColor: category.color }}
                >
                  <h3
                    className="text-lg md:text-xl font-bold group-hover:scale-110 transition-transform duration-300 absolute top-6 left-6 z-10"
                    style={{ color: '#0d0d0d' }}
                  >
                    <T keyName={category.nameKey}>{category.name}</T>
                  </h3>
                  {/* Imagen del producto */}
                  <div className="absolute -bottom-2 -right-4 w-3/4 h-3/4 flex items-center justify-center">
                    <OptimizedImage
                      src={category.image}
                      alt={category.name}
                      width={175}
                      height={219}
                      type="product"
                      responsive={true}
                      className="w-full h-full object-contain"
                      onerror="redirect"
                    />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories; 